export default "__VITE_ASSET__DpBZ$AwM__"